import {useSelector} from 'react-redux'
import useGetResidentsByOccupancy from './useGetResidentsByOccupancy'

function useGetOccupancyWithResidentAndUnitData(occupancyId) {
  const occupancy = useSelector(state => state.Occupancies.occupanciesLookup[occupancyId]) || {}
  const unit = useSelector(state => state.Units.unitsLookup[occupancy.occupancyUnitId])
  const residents = useGetResidentsByOccupancy(occupancyId)

  return {
    ...occupancy,
    residents: residents,
    unit: unit,
  }
}
export default useGetOccupancyWithResidentAndUnitData
